import axios from "axios";

const api = axios.create({
  //baseURL: "http://localhost:8081/"
  baseURL: "https://semaforo-back-dev.herokuapp.com/"
});

export default api;
